import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { UtilityService, HttpClientService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { throwError } from 'rxjs';

import { HttpResponse, HttpHeaders } from '@angular/common/http';
import { ANALYTICS_CONSTANTS } from 'config';
declare var ENV_PORTAL;

@Injectable()
export class InitialService {
  constructor(private utilityService: UtilityService,
    private httpClientService: HttpClientService, private adobeAnalyticsService: AdobeAnalyticsService) { }

  handleError = (error) => {
    return throwError(error);
  }

  getInitialDetails() {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'text/json');
    headers = headers.append('SERVICE-AUTH-TOKEN', sessionStorage.getItem('sapmp_jwtToken'));
    return this.httpClientService.get(this.utilityService.getEnvConfig().initialUrl, headers)
      .pipe(
       map((res: HttpResponse<any>) => {
        if (res.headers.get('SERVICE-AUTH-TOKEN') != null) {
          this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
        }
        return res.body;
      }
      )
      ,catchError( this.handleError ));
  }

  createPageLoadProperties(url: string, title: string, friendlyPageName: string) {
    const dataLayer = {};
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = friendlyPageName;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_MANAGE;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LANGUAGE] = 'EN';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'shoplogin';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Service';
    this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
  }

  getHeaders() {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
    return headers;
  }

  fetchJSON(dataurl) {
    return this.httpClientService.post(dataurl, this.getHeaders())
      .pipe(
       map((resp: HttpResponse<any>) => resp.body)
      ,catchError( this.handleError ));
  }

  signupDetails1(emmProductCode, selectedProductId) {
    let finalResp;
    let data = {
      'resellerId': '6004067397',
      'ids': [
        selectedProductId
      ]
    };
    if (emmProductCode === 'DMPSKME') {
      finalResp = this.utilityService.getEnvConfig().getSamsungId, data;
    }
    return this.httpClientService.post(finalResp, this.getHeaders())
      .pipe(
       map((res: HttpResponse<any>) => { // console.log(res+ ' --------- validation');
        if (res.headers.get('SERVICE-AUTH-TOKEN') != null) {
          this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
        }
        return res.body;
      }
      )
      ,catchError( this.handleError ));
  }

  signupDetails(emmProductCode, selectedProductId) {
    let finalResp, MdmUrl;
    const data = {
      'resellerId': '6004067397',
      'ids': [
        selectedProductId
      ]
    };
    return this.httpClientService.post(this.utilityService.getEnvConfig().getSamsungId, data, this.getHeaders())
      .pipe(
       map((res: HttpResponse<any>) => { // console.log(res+ ' --------- validation');
        if (res.headers.get('SERVICE-AUTH-TOKEN') != null) {
          this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
        }
        return res.body;
      }
      )
      ,catchError( this.handleError ));
  }

  mdmDetails() {
    return this.httpClientService.get(this.utilityService.getEnvConfig().mdmDetails, this.getHeaders())
      .pipe(
       map((res: HttpResponse<any>) => {
        if (res.headers.get('SERVICE-AUTH-TOKEN') != null) {
          this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
        }
        return res.body;
      }
      )
      ,catchError( this.handleError ));
  }

  samsungValidate() {
    let samsungKmeId;
    samsungKmeId = sessionStorage.getItem('selectedAccID');
    const data = {
      'resellerId': '6004067397',
      'ids': [
        samsungKmeId
      ]
    };
    return this.httpClientService.post(this.utilityService.getEnvConfig().samsungValidate, data, this.getHeaders())
      .pipe(
       map((resp: HttpResponse<any>) => { // console.log(resp);
        return resp.body;
      }
      )
      ,catchError( this.handleError ));
  }
}